import Loading from 'modules/core/components/Loading'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { Navigate, useParams } from 'react-router-dom'

interface PostInsightsFeatureFlagGuardProps {
  children: React.ReactNode
}

const PostInsightsFeatureFlagGuard = ({ children }: PostInsightsFeatureFlagGuardProps) => {
  const { navigation } = useNavigation()
  const id = useParams().id ?? ''
  const { has_dev_communities_post_insights, loadingFeatures } = useFeatures([
    'dev_communities_post_insights',
  ])

  if (loadingFeatures) return <Loading />

  if (!has_dev_communities_post_insights) {
    return <Navigate replace to={navigation.communities.post.id.fullPath({ id })} />
  }

  return <>{children}</>
}

export default PostInsightsFeatureFlagGuard
